'use client';

import { Button } from '@e6/ds/core';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSidebar } from '@/providers/SidebarProvider';

export function SidebarToggle() {
  const { isOpen, toggle } = useSidebar();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      className={cn(
        'text-sidebar-foreground h-8 w-8',
        'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
        'transition-colors',
        !isOpen && 'mx-auto'
      )}
      aria-label={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
      aria-expanded={isOpen}
    >
      {isOpen ? <ChevronLeft className="icon-14" /> : <ChevronRight className="icon-14" />}
    </Button>
  );
}
